import { Download, Link2 } from "lucide-react";
import { toast } from "sonner";

const ARTICLE_URL =
  "https://www.fraserinstitute.org/commentary/municipal-debt-rising-substantially-some-ontario-cities";

const copySourceLink = async () => {
  try {
    await navigator.clipboard.writeText(ARTICLE_URL);
    toast.success("Source link copied — share it anywhere.");
  } catch {
    toast.info(`Share this link: ${ARTICLE_URL}`);
  }
};

const QUOTES = [
  {
    quote:
      "I recently had the opportunity to sit down for coffee with Joel Bruce, and I came away really impressed by how personal, approachable, and genuinely interested he is in the issues facing our community. What really resonated with me is Joel's willingness to challenge the status quo. He believes municipal government works best when it listens to the people it represents — not through a top-down approach, but through conversation, collaboration, and a grassroots approach to finding solutions. I'm pleased to support Joel Bruce in his campaign for Kingston City Council. I believe his willingness to listen, ask questions, and engage with the community would bring a valuable perspective to Council.",
    name: "Mike Wilson",
    detail: "Emerald Acre Retreat",
  },
  {
    quote:
      "Having known Joel for almost ten years, he has demonstrated he is an approachable, supportive, and hardworking individual. Collins-Bayridge District would be lucky to have him represent and deliver for our community!",
    name: "Jen Housh",
    detail: "AsterandAshStudio",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      className="scroll-mt-36 border-t border-[#DCDCD6] bg-[#EBEBE6] px-6 py-24 md:scroll-mt-24 md:py-32"
      data-testid="testimonials-section"
    >
      <div className="mx-auto max-w-6xl">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#666666]">
          From the Community
        </p>
        <h2 className="mt-4 font-serif text-3xl font-light leading-tight tracking-tight md:text-5xl">
          Testimonials and Endorsements
        </h2>
        <div className="mt-14 flex flex-col gap-8">
          {QUOTES.map((q, i) => (
            <figure
              key={q.name}
              className="border border-[#DCDCD6] bg-[#F4F4F0] p-8 md:p-12"
              data-testid={`testimonial-${i + 1}`}
            >
              <span
                className="font-serif text-6xl font-light leading-none text-[#DCDCD6]"
                aria-hidden="true"
              >
                “
              </span>
              <blockquote className="-mt-4 max-w-4xl font-serif text-lg font-light leading-relaxed tracking-tight md:text-2xl">
                {q.quote}
              </blockquote>
              <figcaption className="mt-8 border-t border-[#DCDCD6] pt-4">
                <p className="text-xs font-bold uppercase tracking-[0.2em]">{q.name}</p>
                <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.2em] text-[#999999]">
                  {q.detail}
                </p>
              </figcaption>
            </figure>
          ))}
        </div>
        <p className="mt-10 text-center text-[10px] font-bold uppercase tracking-[0.25em] text-[#999999]">
          Community voices — send yours through the contact form below
        </p>
        <figure className="mx-auto mt-12 max-w-4xl">
          <a
            href="https://www.fraserinstitute.org/commentary/municipal-debt-rising-substantially-some-ontario-cities"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="fraser-institute-link"
            className="group block border border-[#DCDCD6] bg-[#F4F4F0] transition-colors duration-300 hover:border-[#111111]"
          >
            <img
              src="/fraser-figure2-official.jpeg"
              alt="Fraser Institute Figure 2: Total municipal debt per capita added from 2004 to 2023, major Ontario municipalities — Kingston highest at $2,784"
              className="w-full"
              data-testid="fraser-chart-image"
            />
            <figcaption className="flex flex-wrap items-center justify-between gap-2 border-t border-[#DCDCD6] px-6 py-4 text-left">
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 group-hover:text-[#666666]">
                Kingston - The most indebted municipality in Ontario (per capita) →
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#999999]">
                Data: Fraser Institute, June 2025
              </span>
            </figcaption>
          </a>
        </figure>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-4">
          <a
            href="/municipal-debt-fraser-institute.pdf"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="fraser-pdf-button"
            className="flex items-center gap-3 border border-[#111111] bg-[#DCDCD6] px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0]"
          >
            Download the report
            <Download className="h-4 w-4" />
          </a>
          <button
            onClick={copySourceLink}
            data-testid="fraser-share-button"
            className="flex items-center gap-3 border border-[#111111] bg-[#DCDCD6] px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0]"
          >
            Share source link
            <Link2 className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
};
